/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Thu Sep 09 2021 10:51:26 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_BASE_URL_DOCUMENT } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_BASE_URL_DOCUMENT;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface DocListSearchResponse {
  checkcategory: string;
  checkreceiverid: number;
  checkreceiverroleprofile: string;
  checkreceivertype: string;
  creationdate: string;
  creationusername: string;
  doccheckstatus: string;
  doccheckstatuslabel: string;
  doccheckuserid: number;
  doccheckusername: string;
  doccode: string;
  docdoublecheck: boolean;
  docid: number;
  doclabel: string;
  docmodule: string;
  docmodulelabel: string;
  docpath: string;
  docrequesttype: string;
  docstatus: string;
  docstatuscomment: string;
  docstatuslabel: string;
  docstatusreason: string;
  docstatusreasonlabel: string;
  doctype: string;
  doctypelabel: string;
  id: number;
  objectid: number;
  objectreference: string;
  overridereceiverid: number;
  overridereceiverroleprofile: string;
  overridereceivertype: string;
  requesttypelabel: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  userid: number;
}

export interface ParDocument {
  applicationrule: string;
  checkcategory: string;
  checkreceiverid: number;
  checkreceiverroleprofile: string;
  checkreceivertype: string;
  doccode: string;
  docdoublecheck: boolean;
  docmodule: string;
  docrequesttype: string;
  docstatus: string;
  doctype: string;
  docvaliditymonths: number;
  overridereceiverid: number;
  overridereceiverroleprofile: string;
  overridereceivertype: string;
  pardocid: number;
}

export interface ParDocumentRequest {
  applicationrule: string;
  applicationrulerequest: string;
  applicationruledisplay: string;
  checkcategory: string;
  checkreceiverid: number;
  checkreceiverroleprofile: string;
  checkreceivertype: string;
  doccode: string;
  docdoublecheck: boolean;
  doclabel: string;
  docmodule: string;
  docrequesttype: string;
  docstatus: string;
  docstatuslabel?: string;
  doctype: string;
  docvaliditymonths: number;
  overridereceiverid: number;
  overridereceiverroleprofile: string;
  overridereceivertype: string;
  pardocid: number;
}

export interface ParDocumentResponse {
  doccode: string;
  doclabel: string;
}

export interface ParDocumentsResponse {
  applicationrule: string;
  applicationrulerequest: string;
  applicationruledisplay: string;
  checkcategory: string;
  checkreceiverid: number;
  checkreceiveridname: string;
  checkreceiverroleprofile: string;
  checkreceiverroleprofilelabel: string;
  checkreceivertype: string;
  checkreceivertypelabel: string;
  doccode: string;
  doccodelabel: string;
  docdoublecheck: boolean;
  doclabel: string;
  docmodule: string;
  docmodulelabel: string;
  docrequesttype: string;
  docrequesttypelabel: string;
  docstatus: string;
  docstatuslabel: string;
  doctype: string;
  doctypelabel: string;
  docvaliditymonths: number;
  overridereceiverid: number;
  overridereceiveridname: string;
  overridereceiverroleprofile: string;
  overridereceiverroleprofilelabel: string;
  overridereceivertype: string;
  overridereceivertypelabel: string;
  pardocid: number;
}

export interface DocListsResponse {
  applicationrule: string;
  applicationruledisplay: string;
  applicationrulerequest: string;
  checkcategory: string;
  checkcategorylabel: string;
  doccode: string;
  docdoublecheck: boolean;
  doclabel: string;
  docmodule: string;
  docmodulelabel: string;
  docrequesttype: string;
  docrequesttypelabel: string;
  docstatus: string;
  docstatuslabel: string;
  doctype: string;
  doctypelabel: string;
  pardocid: number;
}

export interface MgDocumentPk {
  mgid: number;
  pardocid: number;
}
export interface MgDocument {
  mgDocumentPk: MgDocumentPk;
  startdate: string;
  enddate: string;
}

export interface MgDocumentResponse {
  mgid: number;
  pardocid: number;
  startdate: string;
  enddate: string;
}

export interface MgDocumentRequest {
  mgid: number;
  pardocid: number;
  startdate: string;
  enddate: string;
}

export interface UpdateDocPathParams {
  doccode: string;
  docmodule: string;
  docpath: string;
  objectid: number;
}

/**
 * @tags Document Controller
 * @summary updateDocPath
 */
export function updateDocPath(params: UpdateDocPathParams) {
  return request.put<AbstractResponse<object, DocListSearchResponse>>(
    `${URL}/UpdateDocPath` +
      prepareQueryParams({
        doccode: params.doccode,
        docmodule: params.docmodule,
        docpath: params.docpath,
        objectid: params.objectid,
      } as any)
  );
}

export interface UpdateDocPathByDocidParams {
  docid: number;
  docmodule: string;
  docpath: string;
  objectid: number;
}

/**
 * @tags Document Controller
 * @summary updateDocPathByDocid
 */
export function updateDocPathByDocid(params: UpdateDocPathByDocidParams) {
  return request.put<AbstractResponse<object, DocListSearchResponse>>(
    `${URL}/UpdateDocPathByDocid` +
      prepareQueryParams({
        docid: params.docid,
        docmodule: params.docmodule,
        docpath: params.docpath,
        objectid: params.objectid,
      } as any)
  );
}

export interface UpdateDocStatusByDocidParams {
  checkcategory: string;
  doccheckstatus: string;
  docid: number;
  docmodule: string;
  docstatus: string;
  docstatuscomment: string;
  docstatusreason: string;
  objectid: number;
}

/**
 * @tags Document Controller
 * @summary updateDocStatusByDocid
 */
export function updateDocStatusByDocid(params: UpdateDocStatusByDocidParams) {
  return request.put<AbstractResponse<object, DocListSearchResponse>>(
    `${URL}/UpdateDocStatusByDocid` +
      prepareQueryParams({
        checkcategory: params.checkcategory,
        doccheckstatus: params.doccheckstatus,
        docid: params.docid,
        docmodule: params.docmodule,
        docstatus: params.docstatus,
        docstatuscomment: params.docstatuscomment,
        docstatusreason: params.docstatusreason,
        objectid: params.objectid,
      } as any)
  );
}

export interface AddDocumentParams {
  doccode: string;
  docmodule: string;
  docpath: string;
  doctype: string;
  objectid: number;
  checkcategory: string;
  tpid: number;
  tpreference: string;
  tpname: string;
  taskid?: number;
  flagattachment?: boolean;
}

/**
 * @tags Document Controller
 * @summary addDocument
 */
export function addDocument(params: AddDocumentParams) {
  return request.post<AbstractResponse<object, DocListSearchResponse>>(
    `${URL}/addDocument` +
      prepareQueryParams({
        doccode: params.doccode,
        docmodule: params.docmodule,
        docpath: params.docpath,
        doctype: params.doctype,
        objectid: params.objectid,
        checkcategory: params.checkcategory,
        tpid: params.tpid,
        tpreference: params.tpreference,
        tpname: params.tpname,
        taskid: params.taskid,
        flagattachment: params.flagattachment,
      } as any)
  );
}

/**
 * @tags Document Controller
 * @summary getBuildingInfo
 */
export function getBuildingInfo() {
  return request.get<string>(`${URL}/doc/version`);
}

export interface FindDocumentsByAnyRefParams {
  checkcategory: string;
  doccode: string;
  docmodule: string;
  docstatus: string;
  doctype: string;
  objectid: number;
  objectreference: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  applyFilter: boolean;
  taskid: number;
}

/**
 * @tags Document Controller
 * @summary findDocumentsByAnyRef
 */
export function findDocumentsByAnyRef(params: FindDocumentsByAnyRefParams) {
  return request.get<AbstractResponse<object, DocListSearchResponse>>(
    `${URL}/findDocumentsByAnyRef` +
      prepareQueryParams({
        checkcategory: params.checkcategory,
        doccode: params.doccode,
        docmodule: params.docmodule,
        docstatus: params.docstatus,
        doctype: params.doctype,
        objectid: params.objectid,
        objectreference: params.objectreference,
        tpid: params.tpid,
        tpname: params.tpname,
        tpreference: params.tpreference,
        applyFilter: params.applyFilter,
        taskid: params.taskid,
      } as any)
  );
}

export interface GetParDocumentByTypeParams {
  checkcategory: string;
  docmodule: string;
  doctype: string;
  objectid: number;
  addboth: boolean;
  docstatus?: string;
}

/**
 * @tags Document Controller
 * @summary getParDocumentByType
 */
export function getParDocumentByType(params: GetParDocumentByTypeParams) {
  return request.get<AbstractResponse<object, ParDocumentResponse>>(
    `${URL}/getParDocumentByType` +
      prepareQueryParams({
        checkcategory: params.checkcategory,
        docmodule: params.docmodule,
        doctype: params.doctype,
        objectid: params.objectid,
        addboth: params.addboth,
        docstatus: params.docstatus,
      } as any)
  );
}

export interface GetParDocumentListByCriteriaParams {
  checkcategory: string;
  doccode: string;
  docmodule: string;
  docrequesttype: string;
  docstatus: string;
  doctype: string;
}

/**
 * @tags Par Document Controller
 * @summary getParDocumentListByCriteria
 */
export function getParDocumentListByCriteria(
  params: GetParDocumentListByCriteriaParams
) {
  return request.get<AbstractResponse<object, DocListsResponse>>(
    `${URL}/pardocument` +
      prepareQueryParams({
        checkcategory: params.checkcategory,
        doccode: params.doccode,
        docmodule: params.docmodule,
        docrequesttype: params.docrequesttype,
        docstatus: params.docstatus,
        doctype: params.doctype,
      } as any)
  );
}

export interface CreateParDocumentParams {
  request: ParDocumentRequest;
}

/**
 * @tags Par Document Controller
 * @summary createParDocument
 */
export function createParDocument(params: CreateParDocumentParams) {
  return request.post<AbstractResponse<ParDocumentRequest, object>>(
    `${URL}/pardocument`,
    params.request
  );
}

export interface GetParDocumentDetailParams {
  doccode: string;
}

/**
 * @tags Par Document Controller
 * @summary getParDocumentDetail
 */
export function getParDocumentDetail(params: GetParDocumentDetailParams) {
  return request.get<AbstractResponse<ParDocumentsResponse, object>>(
    `${URL}/pardocument/${params.doccode}`
  );
}

export interface UpdateParDocumentParams {
  doccode: string;
  request: ParDocumentRequest;
}

/**
 * @tags Par Document Controller
 * @summary updateParDocument
 */
export function updateParDocument(params: UpdateParDocumentParams) {
  return request.put<AbstractResponse<ParDocumentRequest, object>>(
    `${URL}/pardocument/${params.doccode}`,
    params.request
  );
}

export interface UpdateParDocumentStatusParams {
  docStatus: string;
  doccode: string;
}

/**
 * @tags Par Document Controller
 * @summary updateParDocumentStatus
 */
export function updateParDocumentStatus(params: UpdateParDocumentStatusParams) {
  return request.put<AbstractResponse<ParDocument, object>>(
    `${URL}/pardocument/${params.doccode}/${params.docStatus}`
  );
}

export interface UpdateDocStatusParams {
  doccheckstatus: string;
  docid: number;
  docstatus: string;
  docstatuscomment: string;
  docstatusreason: string;
}

/**
 * @tags Document Controller
 * @summary updateDocStatus
 */
export function updateDocStatus(params: UpdateDocStatusParams) {
  prepareQueryParams({
    doccheckstatus: params.doccheckstatus,
    docid: params.docid,
    docstatus: params.docstatus,
    docstatuscomment: params.docstatuscomment,
    docstatusreason: params.docstatusreason,
  });
  return request.put<AbstractResponse<object, object>>(
    `${URL}/updateDocStatus` +
      prepareQueryParams({
        doccheckstatus: params.doccheckstatus,
        docid: params.docid,
        docstatus: params.docstatus,
        docstatuscomment: params.docstatuscomment,
        docstatusreason: params.docstatusreason,
      })
  );
}

export interface GetMgDocumentListParams {
  pardocid: number;
}

/**
 * @tags Document Controller
 * @summary findDocumentsByAnyRef
 */
export function getMgDocumentList(params: GetMgDocumentListParams) {
  return request.get<AbstractResponse<object, MgDocumentResponse>>(
    `${URL}/mgdocument/${params.pardocid}`
  );
}

export interface AddMgDocumentParams {
  request: MgDocumentRequest;
}

/**
 * @tags Par Document Controller
 * @summary createParDocument
 */
export function addMgDocument(params: AddMgDocumentParams) {
  return request.post<AbstractResponse<MgDocumentRequest, object>>(
    `${URL}/mgdocument`,
    params.request
  );
}

export interface RemoveMgDocumentParams {
  mgid: number;
  pardocid: number;
}

/**
 * @tags Shop Config Controller
 * @summary RemoveParMarketingLabel
 */
export function removeMgDocument(params: RemoveMgDocumentParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/mgdocument/${params.mgid}/${params.pardocid}`
  );
}

/**
 * @tags Document Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/version`);
}

export interface UploadDocumentParams {
  file: any;
  objectReference: string;
}

/**
 * @tags Upload Document Controller
 * @summary UploadDocument
 */
export function UploadDocument(params: UploadDocumentParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/upload` +
      prepareQueryParams({
        objectReference: params.objectReference,
      }),
    params.file
  );
}

export interface LoadFileAsResourceParams {
  filename: string;
}

/**
 * @tags loadFileAsResource Document Controller
 * @summary loadFileAsResource
 */
export function loadFileAsResource(params: LoadFileAsResourceParams) {
  return request.post<any>(
    `${URL}/getfile/${params.filename}`
  );
}
